import axiosInstance from "services/AxiosInstance";

export const getSupplierName = async (supplierId: string) => {
  const response = await axiosInstance.get(`/suppliers/${supplierId}`);
  return response.data;
};
